import styled from '@emotion/styled';
import { FormInput } from 'components/molecules/FormInput';

export const StyledFormInput = styled(FormInput)`
  & input {
    height: 40px;
  }
`;
